import React from 'react';
import { tonelabContent } from '../rich-content/tonelab-complete-content';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';

const TonelabDetailPage = () => {
  return <AutomaticPageBuilder content={tonelabContent} />;
};

export default TonelabDetailPage;